import { render, staticRenderFns } from "./QrcodeReader.vue?vue&type=template&id=04b2bc54&lang=html&"
import script from "./QrcodeReader.vue?vue&type=script&lang=js&"
export * from "./QrcodeReader.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeReader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports